$(function() {
    var $body = $('body');
    var $siteHeader = $(".site-header");
    var $infoBanner = $('.site-header__alert');
    var $btnAlertClose = $('#header-alert-close');

    var paddingRemove = parseInt($body.css('padding-top')) - $infoBanner.height();
    
    $body.css("padding-top", $siteHeader.outerHeight());

    var refreshHeaderHeight = function() {

        console.log($siteHeader.outerHeight());

        if($infoBanner.length) {
            var shouldHideAlert = window.sessionStorage.getItem('sila:hide-alert');
            $('.header__nav-wrapper .sub-menu').addClass('alert-added');
    
            if(!shouldHideAlert || shouldHideAlert != 1) {
                $infoBanner.removeClass('is-hidden');
                $siteHeader.addClass('no-alert');
            }
    
            $btnAlertClose.on('click', function() {
                $infoBanner.addClass('is-hidden');
                $('.header__nav-wrapper .sub-menu').removeClass('alert-added');
    
                window.sessionStorage.setItem('sila:hide-alert', '1');
                
                $body.css("padding-top", paddingRemove);
                
                if($infoBanner.length) {
                    $siteHeader.addClass('no-alert');
                }
            })
        }
    };

    refreshHeaderHeight();

    $(window).on('resize', refreshHeaderHeight);
    $(window).on('webfont:loaded', refreshHeaderHeight);
    $(window).imagesLoaded(function () {
        refreshHeaderHeight
    });
        
});

// var html = $('html');
// var button = $('.button--plus');

//     $('.button--plus').click(function() {
//         checkClasses();
//     });
//     $('.button--minus').on('click', function() {
//         checkClasses();
//     })
//     function checkClasses() {
//         if(html.hasClass('zoom-125')) {
//             $('body').addClass('zoom-125');
//             $('body').removeClass('zoom-150');
//         } else if (html.hasClass('zoom-150')) {
//             $('body').addClass('zoom-150');
//             $('body').removeClass('zoom-125');
//         }   
//     }
// });